import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { USERS_API_URL } from '../../config/apiConfig';

const api = axios.create({ baseURL: USERS_API_URL });

const HomeScreen = () => {
  const [whatsNewSections, setWhatsNewSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadWhatsNewSections = async () => {
      try {
        const response = await api.get('/whats-new-sections');
        setWhatsNewSections(response.data.sections || []);
      } catch (error) {
        console.error('Error loading What\'s New sections:', error);
        setWhatsNewSections([
          {
            section_id: 'fallback',
            title: "What's New",
            content_html: `
              <h3>Welcome to AmpNebula</h3>
              <p><strong>Latest Updates:</strong></p>
              <ul>
                <li><strong>New Amplifier Search</strong> — Find amplifiers by name, manufacturer, year, model, or serial number</li>
                <li><strong>Enhanced Security</strong> — Role-based access control with public page support</li>
                <li><strong>Improved UI</strong> — Better navigation and user experience</li>
                <li><strong>Component Management</strong> — Full CRUD operations for amplifier components</li>
              </ul>
              <p><em>More exciting features coming soon!</em></p>
              <hr style="margin: 1.5rem 0; border: none; border-top: 1px solid #e9ecef;" />
              <h4>Getting Started</h4>
              <p>Navigate through the sidebar to:</p>
              <ul>
                <li><strong>Search Amplifiers</strong> — Discover amplifier information</li>
                <li><strong>Browse Categories</strong> — Explore component categories</li>
                <li><strong>Manage Data</strong> — Add and edit amplifiers, components, and more</li>
              </ul>
            `,
            display_order: 1
          }
        ]);
      } finally {
        setLoading(false);
      }
    };
    loadWhatsNewSections();
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f8f9fa'
    }}>
      <div style={{
        maxWidth: '1100px',
        margin: '0 auto',
        padding: '2rem 1.5rem'
      }}>
        {/* Hero Section */}
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <div style={{ position: 'relative', display: 'inline-block' }}>
            <img
              src="/AmpNebulaLarge.jpg"
              alt="AmpNebula"
              style={{
                maxWidth: '350px',
                width: '100%',
                height: 'auto',
                borderRadius: '12px',
                border: '2px solid #e0e0e0',
                boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)',
                padding: '8px',
                background: 'white'
              }}
            />
            <span style={{
              position: 'absolute',
              top: '68%',
              right: '10%',
              fontSize: '0.6rem',
              color: 'rgba(0,0,0,0.45)',
              fontWeight: '600',
              lineHeight: 1
            }}>™</span>
          </div>

          <p style={{
            fontSize: '1.1rem',
            color: '#666',
            maxWidth: '650px',
            margin: '1.5rem auto 0',
            lineHeight: '1.7'
          }}>
            The most comprehensive amp database on the internet, with images, technical documents and discussion forums.
          </p>
        </div>

        {/* What's New Sections */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))',
          gap: '1.5rem'
        }}>
          {loading ? (
            <div style={{
              background: 'white',
              borderRadius: '10px',
              padding: '2rem',
              border: '1px solid #e9ecef',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
              textAlign: 'center',
              color: '#888'
            }}>
              <div style={{
                display: 'inline-block',
                width: '18px',
                height: '18px',
                border: '2px solid #e9ecef',
                borderTop: '2px solid #2563eb',
                borderRadius: '50%',
                animation: 'spin 0.7s linear infinite',
                marginRight: '0.5rem',
                verticalAlign: 'middle'
              }} />
              Loading latest updates...
            </div>
          ) : (
            whatsNewSections.map((section, index) => (
              <div
                key={section.section_id || index}
                style={{
                  background: 'white',
                  borderRadius: '10px',
                  padding: '1.5rem',
                  border: '1px solid #e9ecef',
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
                  transition: 'box-shadow 0.15s ease, border-color 0.15s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                  e.currentTarget.style.borderColor = '#ccc';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0, 0, 0, 0.06)';
                  e.currentTarget.style.borderColor = '#e9ecef';
                }}
              >
                <h2 style={{
                  margin: '0 0 1rem 0',
                  color: '#333',
                  fontSize: '1.25rem',
                  fontWeight: '600'
                }}>
                  {section.title}
                </h2>
                <div
                  style={{
                    lineHeight: '1.6',
                    color: '#555',
                    fontSize: '0.95rem'
                  }}
                  dangerouslySetInnerHTML={{ __html: section.content_html }}
                />
              </div>
            ))
          )}
        </div>
      </div>

      {/* Inject spin keyframes */}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default HomeScreen;
